module.exports = __webpack_public_path__ + "static/media/hanko.1f2788af.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/hanko.png
// module id = 306
// module chunks = 0